import React from 'react';
import './Hero.css'; 
import fondoHero from '../assets/fondo.png';
import imgRect160 from '../assets/Rectangle 160.png';
import imgRect161 from '../assets/Rectangle 161.png';
import imgRect162 from '../assets/Rectangle 162.png';
import imgRect163 from '../assets/Rectangle 163.png';
import fadeImage from '../assets/Fade.png';

const Hero = () => {
  return (
    <section 
      className="hero-section" 
      style={{ backgroundImage: `url(${fondoHero})` }}
    >
      <div 
        className="hero-fade-overlay" 
        style={{ backgroundImage: `url(${fadeImage})` }}
      ></div>

      <div className="hero-content">
        <div className="hero-text">
          <h1>Encontrá las mejores ofertas en componentes de computadora.</h1>
          <p>¡Descuentos en CPUs, GPUs, Motherboards y mas!</p>
        </div>
        <div className="hero-image-grid">
          <img src={imgRect160} alt="Componente 1" />
          <img src={imgRect161} alt="Componente 2" />
          <img src={imgRect162} alt="Componente 3" />
          <img src={imgRect163} alt="Componente 4" />
        </div>
      </div>
    </section>
  );
};

export default Hero;